import { useLoginController } from "./controller";
import LOGO from "../../assets/images/ant-logo-final.jpeg";
import { Box, Grid, Stack, TextField, Typography } from "@mui/material";
import ErrorMessageComponent from "../../components/errorMessage";
import { LoadingButton } from '@mui/lab';
import useScreen from "../../hooks/useScreen";
import { useTranslation } from 'react-i18next';
import LanguagePopover from "../../components/LanguagePopover";

export default function LoginView() {
    const { onSubmit, username, password, errorMessage, loggingIn } = useLoginController();
    const { isMobileScreen } = useScreen();
    const { t } = useTranslation("global");

    return <Box>
        <Box pr={5} sx={{ height: 50, display: 'flex', alignItems: 'center' }}>
            <Stack
                flexGrow={1}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={{ xs: 0.5, sm: 1.5 }}

            >
                <LanguagePopover />
            </Stack>
        </Box>
        <Grid container spacing={2} sx={{ height: 'calc(100vh - 50px)', display: 'flex', alignItems: 'center' }}>
            {
                !isMobileScreen
                &&
                <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={LOGO} alt="Logo" style={{ width: '50%', objectFit: 'contain', borderRadius: "16px" }} />
                    </Box>
                </Grid>
            }
            <Grid item xs={12} sm={6} >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                    <Box sx={{
                        backgroundColor: '#EBF9FF',
                        borderRadius: '16px',
                        p: "10%",
                        width: '100%',
                        maxWidth: 500
                    }}>
                        <Typography variant="h5" sx={{ mb: 4 }} textAlign="center">{t('Welcome to Ant Ecommerce')}</Typography>
                        <form onSubmit={onSubmit}>
                            <Box>
                                <Typography>{t('Username')}</Typography>
                                <TextField inputRef={username} required placeholder={t('Enter Username') || ''} fullWidth margin="normal" size="medium" />
                            </Box>
                            <Box>
                                <Typography>{t('Password')}</Typography>
                                <TextField inputRef={password} type="password" placeholder={t('Enter Password') || ''} fullWidth required margin="normal" size="medium" />
                            </Box>
                            <ErrorMessageComponent errorMessage={errorMessage} />
                            <Box mt={2} display="flex" justifyContent="center">
                                <LoadingButton loading={loggingIn} type="submit" variant="contained" sx={{ backgroundColor: '#00AB55', textTransform: 'none', minWidth: 100 }}>{t("Login")}</LoadingButton>
                            </Box>
                        </form>
                    </Box>
                </Box>

            </Grid>
        </Grid>
    </Box>
}